import React from 'react'
import { withTranslation } from 'react-i18next'
import StepOneForm from './StepOneForm'
import LinkItem from 'components/Link'

const StepOne = ({ t }) => {

  return (
    <div className="w-full">
      <h3 className="text-2xl font-bold text-black mb-1">{t('registration.step_one.title')}</h3>
      <div className="w-full mb-2">
        <p className="inline-block">{t('registration.registered')}
          <LinkItem url="/" tag={() => <span className="text-primary font-medium">{t('registration.signin')}</span>} />
        </p>
      </div>
      {/* <p className="text-secondary mb-8">{ t('registration.step_one.content') }</p> */}

      <StepOneForm />
    </div>
  )
}

export default withTranslation()(StepOne)
